import React from "react";

const SurveySkeletonLoader = () => {
  return (
    <div className="d-flex flex-column gap-3 skeleton-pulse">
      {[1, 2, 3].map((i) => (
        <div key={i} className="sr-result-card mb-3" style={{ border: "1px solid #ede7e1", borderRadius: "14px", padding: "1.4rem", backgroundColor: "#ffffff" }}>
          <div className="row g-3 align-items-center">
            {/* Image Placeholder */}
            <div className="col-12 col-sm-auto">
              <div className="skeleton-block rounded-4" style={{ width: "70px", height: "64px" }}></div>
            </div>

            {/* Title & Status Placeholder */}
            <div className="col-12 col-sm">
              <div className="d-flex align-items-center justify-content-between gap-3">
                <div className="w-70">
                  <div className="skeleton-block rounded-2 mb-2" style={{ height: "18px", width: "70%" }}></div>
                  <div className="skeleton-block rounded-2" style={{ height: "12px", width: "40%" }}></div>
                </div>
                <div className="skeleton-block rounded-pill" style={{ height: "28px", width: "80px" }}></div>
              </div>
            </div>

            {/* Metric Rows */}
            <div className="col-12 mt-20 border-top pt20px">
              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-md-center gap-3">
                <div className="d-flex w-100 flex-grow-1">
                  <div className="flex-fill border-end px-2 px-sm-4">
                    <div className="skeleton-block rounded-2 mb-2" style={{ height: "18px", width: "40%" }}></div>
                    <div className="skeleton-block rounded-2" style={{ height: "12px", width: "70%" }}></div>
                  </div>
                  <div className="flex-fill border-end px-2 px-sm-4">
                    <div className="skeleton-block rounded-2 mb-2" style={{ height: "18px", width: "40%" }}></div>
                    <div className="skeleton-block rounded-2" style={{ height: "12px", width: "70%" }}></div>
                  </div>
                  <div className="flex-fill px-2 px-sm-4">
                    <div className="skeleton-block rounded-2 mb-2" style={{ height: "18px", width: "40%" }}></div>
                    <div className="skeleton-block rounded-2" style={{ height: "12px", width: "70%" }}></div>
                  </div>
                </div>
                <div className="skeleton-block rounded-2 flex-shrink-0" style={{ height: "38px", width: "130px" }}></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SurveySkeletonLoader;
